import React, { useEffect, ReactNode, PropsWithChildren } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useDisclosure, Box, Text, CheckIcon } from '@cdl/heartbeat-react';
import { InfoModal } from './InfoModal';
import { highlightLinks } from '../../../shared/utils/highligthLinks';
import * as annotationTaskActions from '../actions/annotation-task.actions';
import {
  annotationTaskSelector,
  previousAnnotationTaskSelector,
} from '../selectors/annotation-task.selectors';

export const SwitchTaskInfo: React.FC<PropsWithChildren> = ({ children }) => {
  const dispatch = useDispatch();
  const annotationTask = useSelector(annotationTaskSelector);
  const previousAnnotationTask = useSelector(previousAnnotationTaskSelector);
  const {
    isOpen: showSwitchTaskModal,
    onClose: closeSwitchTaskModal,
    onOpen: openSwitchTaskModal,
  } = useDisclosure();
  const handleClose = () => {
    closeSwitchTaskModal();
    dispatch(
      annotationTaskActions.setPreviousAnnotationTask({
        previousAnnotationTask: null,
      }),
    );
  };

  const getModalContent = (): ReactNode => {
    if (previousAnnotationTask == null || annotationTask == null) {
      return null;
    }

    return (
      <Box>
        <Box fontWeight='bold'>
          <Text>You achieve the task {previousAnnotationTask.name}.</Text>
          <Text>Now you’re on the task {annotationTask.name}.</Text>
        </Box>
        <Text mt='m'>{highlightLinks(annotationTask.description)}</Text>
      </Box>
    );
  };

  useEffect(() => {
    if (previousAnnotationTask != null) {
      openSwitchTaskModal();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {children}
      {showSwitchTaskModal && (
        <InfoModal
          isOpen={showSwitchTaskModal}
          title={
            <>
              <Text>Congratulations!</Text>
              <Text>Here comes your new project!</Text>
            </>
          }
          onClose={handleClose}
          closeButtonRightIcon={<CheckIcon />}
          withDashedBorder
        >
          {getModalContent()}
        </InfoModal>
      )}
    </>
  );
};
